import { Card, CardContent, Box, Divider, Typography } from '@mui/material'
import FillterMonthAttendance from '@/components/attendance/detail-attendance/FillterMonthAttendance'
import { useRouteQuery } from '@/hooks'
import { Button } from '@/@core/components/mui/Button'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import { Balance } from '@/@data'
import { useQuery } from '@tanstack/react-query'

export const BalanceFilterBar = () => {
  const { __ } = useTranslator()
  const { updateQuery, searchQuery, serializeQuery } = useRouteQuery()
  const navigate = useNavigate()
  const month = searchQuery.get('month')
  const isCurrentOrFutureMonth = dayjs(month).isAfter(dayjs(), 'month') || dayjs(month).isSame(dayjs(), 'month')

  const params = useMemo(
    () =>
      serializeQuery({
        month: month
      }),
    [searchQuery]
  )

  const { data: dataBalanceStatus } = useQuery({
    ...Balance.getBalanceStatus(params)
  })

  return (
    <Card className='rounded-[16px]'>
      <CardContent className='p-6'>
        <div className='flex justify-between items-center'>
          <Box className='flex gap-2 items-center'>
            <Button variant={'outlined'} className='rounded-[20px] h-[32px] text-[14px]'>
              {__('All')}
            </Button>
            <Divider orientation='vertical' flexItem />
            <Typography className='text-[18px] font-medium leading-[28px] '>{__('LIFT Statistics')}</Typography>
          </Box>
          <Button
            variant={'contained'}
            className='rounded-[20px] h-[32px] text-[14px] bg-[#E8E6FC] shadow-none text-[#3551F2]'
            startIcon={<i className='tabler-settings' />}
            onClick={() => {
              navigate('/cms/finance/balance/setting-finance')
            }}
          >
            {__('Setting Finance')}
          </Button>
        </div>
        <Divider className='my-4' />

        <FillterMonthAttendance
          onDateChange={month => {
            updateQuery({ month, page: 1 })
          }}
          isHideDay={true}
          isChooseFuture={true}
          status={isCurrentOrFutureMonth ? 'estimate balance' : dataBalanceStatus?.data?.status}
        />
      </CardContent>
    </Card>
  )
}
